<template>
  <div>
    <!-- 新增/编辑的对话框 -->
    <el-dialog class="edit-dialog" :title="ruleForm.id === '' ? '新增内容' : '编辑内容'" :visible.sync="dialogVisible"
      width="900px" top="100px" :modal-append-to-body="true" append-to-body close-on-click-modal @closed="hide">

      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm">

        <div class="form_bj_box">
          <el-form-item label="策略名称" prop="strategyName">
            <el-input v-model="ruleForm.strategyName" maxlength="99"></el-input>
          </el-form-item>

          <el-form-item label="收端渠道" prop="channelFlag">
            <el-radio-group v-model="ruleForm.channelFlag" @change="() => { ruleForm.receiverChannelNameList = '' }">
              <el-radio label="0">全部渠道</el-radio>
              <el-radio label="1">指定渠道</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="ruleForm.channelFlag == '1'" label="">
            <el-input type="textarea" @focus="handleClick" v-model="ruleForm.receiverChannelNameList">
            </el-input>
          </el-form-item>


          <el-form-item label="uid" prop="receiverUidSet">
            <el-input v-model="ruleForm.receiverUidSet"></el-input>
          </el-form-item>
          <el-form-item label="uuid" prop="receiverUuidSet">
            <el-input v-model="ruleForm.receiverUuidSet"></el-input>
          </el-form-item>

          <el-form-item label="应用版本" prop="apkVersionMax">
            <div style="display: flex; justify-content: space-around; text-align: center;">
              <div>
                <el-input v-model="ruleForm.apkVersionMax"></el-input>
                <div>最大版本</div>
              </div>
              <div>
                <el-input v-model="ruleForm.apkVersionMin"></el-input>
                <div>最小版本</div>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="SDK版本" prop="sdkVersionMax">
            <div style="display: flex; justify-content: space-around; text-align: center;">
              <div>
                <el-input v-model="ruleForm.sdkVersionMax"></el-input>
                <div>最大版本</div>
              </div>
              <div>
                <el-input v-model="ruleForm.sdkVersionMin"></el-input>
                <div>最小版本</div>
              </div>
            </div>
          </el-form-item>
        </div>
        <!-- 默认模式-家庭模式-公开模式 -->
        <div class="form_bj_box" v-for="(item, index) in ruleForm.strategyDetails" :key="index">
          <div class="form_bj_box_title">{{ workPatternName[+item.workPattern] || workPatternName[index + 1] }}
          </div>
          <el-form-item label="白名单" :prop="'strategyDetails.' + index + '.writeListStrategy'">
            <el-radio-group v-model="item.writeListStrategy">
              <el-radio label="1">直接播放</el-radio>
              <el-radio label="2">选择确认</el-radio>
              <el-radio label="3">停止播放</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="灰名单" :prop="'strategyDetails.' + index + '.grayListStrategy'">
            <el-radio-group v-model="item.grayListStrategy">
              <el-radio label="1">直接播放</el-radio>
              <el-radio label="2">选择确认</el-radio>
              <el-radio label="3">停止播放</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="黑名单" :prop="'strategyDetails.' + index + '.blackListStrategy'">
            <el-radio-group v-model="item.blackListStrategy">
              <el-radio label="1">直接播放</el-radio>
              <el-radio label="2">选择确认</el-radio>
              <el-radio label="3">停止播放</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="其他名单" :prop="'strategyDetails.' + index + '.otherListStrategy'">
            <el-radio-group v-model="item.otherListStrategy">
              <el-radio label="1">直接播放</el-radio>
              <el-radio label="2">选择确认</el-radio>
              <el-radio label="3">停止播放</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="“选择确认”提示模板" :prop="'strategyDetails.' + index + '.selectConfirmHitTemp'">
            <el-select v-model="item.selectConfirmHitTemp" placeholder="请选择">
              <el-option v-for="(item, index) in templateList" :key="index" :label="item.templateName"
                :value="item.templateCode"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="“停止播放”提示模板" :prop="'strategyDetails.' + index + '.stopPlayHitTemp'">
            <el-select v-model="item.stopPlayHitTemp" placeholder="请选择">
              <el-option v-for="(item, index) in templateList" :key="index" :label="item.templateName"
                :value="item.templateCode"></el-option>
            </el-select>
          </el-form-item>
        </div>


        <div class="form_bj_box">
          <div class="form_bj_box_title">播放提示</div>
          <el-form-item label="播放提示" prop="toastFlag">
            <el-radio-group v-model="ruleForm.toastFlag">
              <el-radio label="1">开启</el-radio>
              <el-radio label="0">关闭</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="白名单提示" prop="whiteToast">
            <el-input v-model="ruleForm.whiteToast"></el-input>
          </el-form-item>

          <el-form-item label="灰名单提示" prop="grayToast">
            <el-input v-model="ruleForm.grayToast"></el-input>
          </el-form-item>

          <el-form-item label="黑名单提示" prop="blackToast">
            <el-input v-model="ruleForm.blackToast"></el-input>
          </el-form-item>
        </div>


        <div class="form_bj_box no_bjc">
          <el-form-item label="优先级" prop="priority">
            <el-input v-model="ruleForm.priority"></el-input>
          </el-form-item>

          <el-form-item label="生效状态" prop="state">
            <el-radio-group v-model="ruleForm.state">
              <el-radio label="1">生效</el-radio>
              <el-radio label="0">失效</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="备注" prop="remark">
            <el-input v-model="ruleForm.remark" type="textarea" rows="5"></el-input>
          </el-form-item>


        </div>
        <div style="text-align: center;">
          <el-button type="primary" @click="saveBtn">保存</el-button>
          <el-button @click="hide">取消</el-button>
        </div>
      </el-form>

    </el-dialog>
    <channel-popups :app-id="ruleForm.receiverChannelList" :visible.sync="showPopups"
      @comfirm="handleConfirm"></channel-popups>
  </div>
</template>

<script>
import { securityStrategyDetail, securityStrategySave, securityStrategyUpdate, ullHitTemplatePage } from '@/api/apps/securityPolicy';
import ChannelPopups from "@/components/channel-popups";
import Message from "@/components/Message";
export default {
  components: {
    ChannelPopups,
  },
  name: "WebSaaSEdit",
  data() {
    return {
      workPatternName: {
        1: '默认模式', 2: '家庭模式', 3: '公开模式',
      },
      templateList: [], // 模板下拉选项
      title: '新增&编辑内容', // 标题
      showPopups: false, // 渠道选择器
      dialogVisible: false, // 弹框显示
      ruleForm: {
        apkVersionMax: null, // apk最大版本
        apkVersionMin: null, // apk最小版本
        sdkVersionMax: null, // skd最大版本
        sdkVersionMin: null, // skd最小版本
        blackToast: '', // 黑名单播放提示
        channelFlag: '', // 渠道开关：0-全部 1-指定
        grayToast: '', // 灰名单播放提示
        id: '', // id
        priority: '', // 优先级：数字越大优先级越高
        receiverChannelSet: '', // 渠道id list
        receiverChannelList: '',	 // 收端渠道id list		false
        receiverChannelNameList: '',	 // 收端渠道名称 list		false
        receiverUidSet: '', // 收端uid list
        receiverUuidSet: '', // 收端uuid list
        remark: '', // 备注
        state: '', // state
        strategyName: '', // 策略名称
        toastFlag: '', // toast开关：0-关闭 1-开启
        whiteToast: '', // 白名单播放提示
        strategyDetails: [ // 模式	-- 后端会按下标取对应的三个模式，并且吐回来对应下标的数据
          // 1 - 白名单 2 - 灰名单 3 - 黑名单 4 - 其他 名单类型
          // 策略结果：1 - 直接播放 2 - 选择确认 3 - 停止播放
          // 0 - 否 1 - 是
          // workPattern	工作模式 1 - 默认 2 - 家庭 3 - 公共
          {
            blackListStrategy: '', //	黑名单策略		false	string
            grayListStrategy: '', //	灰名单策略		false	string
            otherListStrategy: '', //其他名单策略		false	string
            writeListStrategy: '', //白名单策略		false	string
            selectConfirmHitTemp: '', //	选择默认模板		false	string
            stopPlayHitTemp: '', //	停止播放模板		false	string
            stopPlaySkipFlag: '', //	停止播放跳过标志		false	string
            workPattern: '1', //工作模式		false	string
            customerServiceTemp: 'high_risk_reject_pop', // 2024-8-28 后台要求传固定值
            high_risk_reject_pop: 'public_mode_reject_pop', // 2024-8-28 后台要求传固定值,
            customerServiceRoomTemp: 'meetting_high_risk_reject_pop', // 2024-09-06 后台要求传固定值
            changeEnvRoomTemp: 'meetting_public_mode_reject_pop' // 2024-09-06 后台要求传固定值
          },
          {
            blackListStrategy: '', //	黑名单策略		false	string
            grayListStrategy: '', //	灰名单策略		false	string
            otherListStrategy: '', //其他名单策略		false	string
            writeListStrategy: '', //白名单策略		false	string
            selectConfirmHitTemp: '', //	选择默认模板		false	string
            stopPlayHitTemp: '', //	停止播放模板		false	string
            stopPlaySkipFlag: '', //	停止播放跳过标志		false	string
            workPattern: '2', //工作模式		false	string
            customerServiceTemp: 'high_risk_reject_pop', // 2024-8-28 后台要求传固定值
            high_risk_reject_pop: 'public_mode_reject_pop', // 2024-8-28 后台要求传固定值,
            customerServiceRoomTemp: 'meetting_high_risk_reject_pop', // 2024-09-06 后台要求传固定值
            changeEnvRoomTemp: 'meetting_public_mode_reject_pop' // 2024-09-06 后台要求传固定值
          },
          {
            blackListStrategy: '', //	黑名单策略		false	string
            grayListStrategy: '', //	灰名单策略		false	string
            otherListStrategy: '', //其他名单策略		false	string
            writeListStrategy: '', //白名单策略		false	string
            selectConfirmHitTemp: '', //	选择默认模板		false	string
            stopPlayHitTemp: '', //	停止播放模板		false	string
            stopPlaySkipFlag: '', //	停止播放跳过标志		false	string
            workPattern: '3', //工作模式		false	string
            customerServiceTemp: 'high_risk_reject_pop', // 2024-8-28 后台要求传固定值
            high_risk_reject_pop: 'public_mode_reject_pop', // 2024-8-28 后台要求传固定值,
            customerServiceRoomTemp: 'meetting_high_risk_reject_pop', // 2024-09-06 后台要求传固定值
            changeEnvRoomTemp: 'meetting_public_mode_reject_pop' // 2024-09-06 后台要求传固定值
          },
        ],

      },
      rules: {
        strategyName: [
          { required: true, message: '请输入策略名称', trigger: 'blur' },
        ],
        priority: [
          { required: true, message: '请输入优先级', trigger: 'blur' },
        ],
        state: [
          { required: true, message: '请选择生效状态', trigger: 'change' }
        ],
        channelFlag: [
          { required: true, message: "请选择渠道选择", trigger: "change" }
        ],
        'strategyDetails.0.writeListStrategy': [
          { required: true, message: '请选择白名单策略', trigger: 'change' }
        ],
        'strategyDetails.0.grayListStrategy': [
          { required: true, message: '请选择灰名单策略', trigger: 'change' }
        ],
        'strategyDetails.0.blackListStrategy': [
          { required: true, message: '请选择黑名单策略', trigger: 'change' }
        ],
        'strategyDetails.0.otherListStrategy': [
          { required: true, message: '请选择其他名单策略', trigger: 'change' }
        ],
        'strategyDetails.0.selectConfirmHitTemp': [
          { required: true, message: '请选择“选择确认”提示模板', trigger: 'change' }
        ],
        'strategyDetails.0.stopPlayHitTemp': [
          { required: true, message: '请选择“停止播放”提示模板', trigger: 'change' }
        ],
        'strategyDetails.1.writeListStrategy': [
          { required: true, message: '请选择白名单策略', trigger: 'change' }
        ],
        'strategyDetails.1.grayListStrategy': [
          { required: true, message: '请选择灰名单策略', trigger: 'change' }
        ],
        'strategyDetails.1.blackListStrategy': [
          { required: true, message: '请选择黑名单策略', trigger: 'change' }
        ],
        'strategyDetails.1.otherListStrategy': [
          { required: true, message: '请选择其他名单策略', trigger: 'change' }
        ],
        'strategyDetails.1.selectConfirmHitTemp': [
          { required: true, message: '请选择“选择确认”提示模板', trigger: 'change' }
        ],
        'strategyDetails.1.stopPlayHitTemp': [
          { required: true, message: '请选择“停止播放”提示模板', trigger: 'change' }
        ],
        'strategyDetails.2.writeListStrategy': [
          { required: true, message: '请选择白名单策略', trigger: 'change' }
        ],
        'strategyDetails.2.grayListStrategy': [
          { required: true, message: '请选择灰名单策略', trigger: 'change' }
        ],
        'strategyDetails.2.blackListStrategy': [
          { required: true, message: '请选择黑名单策略', trigger: 'change' }
        ],
        'strategyDetails.2.otherListStrategy': [
          { required: true, message: '请选择其他名单策略', trigger: 'change' }
        ],
        'strategyDetails.2.selectConfirmHitTemp': [
          { required: true, message: '请选择“选择确认”提示模板', trigger: 'change' }
        ],
        'strategyDetails.2.stopPlayHitTemp': [
          { required: true, message: '请选择“停止播放”提示模板', trigger: 'change' }
        ]
      }
    }
  },
  created() {

  },
  methods: {
    // 初始化数据
    async initData(id = '') {
      const resList = await ullHitTemplatePage({ current: 1, size: 9999 })
      console.log('初始化选项数据', resList)
      if (resList.data.code === 200) {
        this.templateList = resList.data.data.records
      }
      if (id === '') return
      const { data } = await securityStrategyDetail({ id: id })
      console.log('初始化详情数据', data)
      if (data.code === 200) {
        this.ruleForm = data.data

        if (data.data.strategyDetails) {
          const res = data.data.strategyDetails.map(item => {
            return {
              ...item,
              customerServiceTemp: item.customerServiceTemp || 'high_risk_reject_pop',
              changeEnvTemp: item.changeEnvTemp || 'public_mode_reject_pop',
              customerServiceRoomTemp: 'meetting_high_risk_reject_pop',
              changeEnvRoomTemp: 'meetting_public_mode_reject_pop'
            }
          })
          this.$set(this.ruleForm, 'strategyDetails', res)
        }


        // 处理后前端需要的数据
        this.ruleForm.receiverChannelList = this.processInput(this.ruleForm.receiverChannelList)
        this.ruleForm.receiverChannelNameList = this.processInput(this.ruleForm.receiverChannelNameList)

        this.ruleForm.receiverUidSet = this.processInput(this.ruleForm.receiverUidSet)
        this.ruleForm.receiverUuidSet = this.processInput(this.ruleForm.receiverUuidSet)
      }
    },

    /** 渠道选择框 */
    handleClick() {
      this.showPopups = true;
    },
    /** 确认渠道选择 */
    handleConfirm(data) {
      console.log("渠道选择的数据", data);
      const { appId, nameStr, isAll } = data;
      if (isAll) {
        this.ruleForm.channelFlag = '0'
      } else {
        this.ruleForm.receiverChannelList = appId;
        this.ruleForm.receiverChannelNameList = nameStr;
      }
    },

    // array---string互转
    processInput(input) {
      // 如果输入是字符串并且不为空
      if (typeof input === 'string' && input.trim().length > 0) {
        // 将字符串按逗号分隔并转换为数组
        return input.split(',');
      }
      // 如果输入是数组并且不为空
      if (Array.isArray(input) && input.length > 0) {
        // 将数组元素连接为一个字符串，元素间用逗号分隔
        return input.join(',');
      }
      // 输入既不是有效字符串也不是有效数组时返回
      if (typeof input === 'string') {
        return []
      }
      if (Array.isArray(input)) {
        return ''
      }
    },

    checkStrategies(array) {
      // 遍历数组中的每一个对象
      return array.every(obj => {
        // 检查对象中的四个键是否至少有一个有值
        return obj.writeListStrategy || obj.blackListStrategy || obj.grayListStrategy || obj.otherListStrategy;
      });
    },

    /* 提交按钮 */
    saveBtn() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {

          // 提交需要校验三个模式，4个名单最少有一个选中，否消息提示
          if (!this.checkStrategies(this.ruleForm.strategyDetails)) {
            Message.error('每个模式，最少有个一个【名单】需要选择')
            return
          }

          const api = this.ruleForm.id ? securityStrategyUpdate : securityStrategySave
          const params = { ...this.ruleForm }
          // 处理成后端需要的数据格式
          params.receiverChannelList = this.processInput(params.receiverChannelList)
          params.receiverChannelNameList = this.processInput(params.receiverChannelNameList)

          params.receiverUidSet = this.processInput(params.receiverUidSet)
          params.receiverUuidSet = this.processInput(params.receiverUuidSet)
          console.log("新增的参数", params);
          const { data } = await api(params);
          console.log("新增的响应", data);
          if (data.code === 200) {
            Message.success("新增成功");
            this.hide();
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },


    //^ ^--------------对话框相关-------------^ ^
    async show(id = '') {
      this.dialogVisible = true;
      this.initData(id)
    },
    hide() {
      /** 清除表单验证规则 */
      this.$refs.ruleForm.resetFields();
      // 数据结构问题，有些数据需要手动归零
      this.ruleForm.strategyDetails = [{}, {}, {}]
      this.ruleForm.sdkVersionMax = null
      this.ruleForm.sdkVersionMin = null
      this.ruleForm.apkVersionMax = null
      this.ruleForm.apkVersionMin = null

      this.dialogVisible = false;
      this.$emit("reload");
    },


  },
};
</script>

<style lang="scss" scoped>
.form_bj_box {
  background-color: #eeeeee;
  margin: 20px;
  padding: 20px 120px 20px 20px;
  border-radius: 5px;

  .form_bj_box_title {
    padding: 20px;
    color: #ff3040;
    font-size: 18px;
    font-weight: bold;
  }

  .form_bj_box_tips {
    color: #ff3040;
    text-align: center;
    font-size: 12px;
  }
}

.no_bjc {
  background-color: #fff;
}
</style>
